<template>
    <section
        class="form-container container"
        :class="[containerDesktopOnly ? 'container--only-desktop' : '']"
        :style="{...generateStylingVariables(content.style)}"
    >
        <zoe-form-generator :content="content" />
    </section>
</template>

<script>
import ZoeFormGenerator from '../../../../../../resources/components/form/zoe-form-generator.vue';
import Component from '../../../../../../resources/mixins/component/component.vue';
import { generateStylingVariables } from '../../../../../../resources/mixins/styling/styling';

export default {
    components: {
        ZoeFormGenerator,
    },

    mixins: [Component],

    props: {
        containerDesktopOnly: {
            type: Boolean,
            default: false,
            required: false,
        },
    },


    methods: {
        generateStylingVariables,
    },

    mounted() {
        this.$store.commit('component/setTemplateValue', {
            component: 'form',
            object: { hasMountedOnce: true },
        });
    },
};
</script>

<style lang="scss">
@use 'step-form';

.form-container {
    --background: v-bind('content.style.background.value');
}
</style>
